import { render, staticRenderFns } from "./type82.vue?vue&type=template&id=225a2161&scoped=true"
import script from "./type82.vue?vue&type=script&lang=js"
export * from "./type82.vue?vue&type=script&lang=js"
import style0 from "./type82.vue?vue&type=style&index=0&id=225a2161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a2161",
  null
  
)

export default component.exports